import PlaceBidCard from "./PlaceBidCard";

export default PlaceBidCard;
